import axios from "axios";
import { API_BASE_URL } from "../../config";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("cms_token")}`,
});

/**
 * Fetch all CMS menus with nested sub-menus
 */
export const fetchCmsMenus = async () => {
  const response = await axios.get(`${API_BASE_URL}/cms-menus`, {
    headers: getAuthHeaders(),
  });

  const data = response?.data?.data;
  if (!Array.isArray(data)) {
    throw new Error(response?.data?.message || "Failed to fetch CMS menus");
  }

  return data;
};
